var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    "data-v-423bf9ae": "",
    xmlns: "http://www.w3.org/2000/svg",
    className: "iconLeft",
    viewBox: "0 0 205.33 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "5c509e7c-f823-4c32-a198-7907d70de58f",
    fill: "white",
    transform: "matrix(6.230529520973259,0,0,6.230529520973259,104.14330047411633,-3.940809029245713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04 4.60L2.95 4.60L2.95 7.58L7.88 7.58L7.88 9.14L2.95 9.14L2.95 12.67L0.94 12.67L0.94 3.04L8.04 3.04L8.04 4.60ZM16.24 12.67L14.32 12.67L14.32 8.52L14.32 8.52Q14.32 6.58 13.00 6.58L13.00 6.58L13.00 6.58Q12.30 6.58 11.88 7.17L11.88 7.17L11.88 7.17Q11.45 7.77 11.45 8.71L11.45 8.71L11.45 12.67L9.53 12.67L9.53 6.93L9.53 6.93Q9.53 6.34 9.51 5.96L9.51 5.96L9.51 5.96Q9.50 5.58 9.47 5.28L9.47 5.28L11.31 5.28L11.31 5.28Q11.33 5.41 11.36 5.97L11.36 5.97L11.36 5.97Q11.40 6.54 11.40 6.75L11.40 6.75L11.42 6.75L11.42 6.75Q11.81 5.90 12.40 5.52L12.40 5.52L12.40 5.52Q12.99 5.13 13.80 5.13L13.80 5.13L13.80 5.13Q14.98 5.13 15.61 5.86L15.61 5.86L15.61 5.86Q16.24 6.58 16.24 7.98L16.24 7.98L16.24 12.67Z"
  }))), /*#__PURE__*/React.createElement("defs", {
    "data-v-423bf9ae": ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    "data-v-423bf9ae": "",
    gradientTransform: "rotate(25)",
    id: "80db9147-bf5d-4391-b95e-24775d1499aa",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "0%",
    style: {
      stopColor: "rgb(10, 55, 50)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "100%",
    style: {
      stopColor: "rgb(85, 195, 136)",
      stopOpacity: 1
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "3e5fc88f-fb82-4f28-b93f-e36d22269e36",
    transform: "matrix(1,0,0,1,-5,-5)",
    stroke: "none",
    fill: "url(#80db9147-bf5d-4391-b95e-24775d1499aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, "&gt;", /*#__PURE__*/React.createElement("path", {
    d: "M50 27.28c-12.528 0-22.72 10.192-22.72 22.72 0 12.528 10.191 22.721 22.72 22.721S72.72 62.528 72.72 50 62.528 27.28 50 27.28zm9.062 14.47H46.507v7.17h10.865v2.731H46.507v10.518h-3.063V39.018h15.618v2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 5C25.147 5 5 25.146 5 50c0 24.853 20.147 45 45 45s45-20.147 45-45C95 25.146 74.853 5 50 5zm0 70.378c-13.993 0-25.377-11.384-25.377-25.378 0-13.993 11.384-25.378 25.377-25.378S75.377 36.007 75.377 50c0 13.994-11.384 25.378-25.377 25.378z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.f86eac0b8cf20bc65142b1721da327e5.svg";
export { ForwardRef as ReactComponent };